import React from "react";
import Quotesection from "../Menchefs/Quotesection";
// import Aboutservice from "../Menabout/Aboutservice";
// import Testimonialsabout from "../Menabout/Testimonialsabout";
import Services from '../Menabout/Services'

import Bredcrumb from "../Bredcrumb/Main";
import Img from "../../assets/images/background/banner-image-5.jpg";

function Main() {
    return (
        <>
            <Bredcrumb
                subtitle="What We Offer"
                title="Our Services"
                Img={Img}
            />
            <Quotesection />
            <Services />
            {/* <Aboutservice /> */}
            {/* <Testimonialsabout /> */}
        </>
    );
}

export default Main;
